export interface Timespan {
  start: string
  end: string
}

export interface PriceCategory {
  id: number
  name: string
  price: number
  has_free_places: boolean
  is_waiting_list_full: boolean
  is_archived: number
  quantity: number
}

export enum CustomQuestionType {
  TEXT = 'text',
  CHOICES = 'answer_choices',
  YESNO = 'yesno',
}

export interface CustomQuestion {
  id: number
  label: string
  description: string
  required: boolean
  type: CustomQuestionType
  choices: string[]
  scope: string
}

export interface CustomAnswer {
  question_id: number
  question_label: string
  question_type: CustomQuestionType
  question_description: string
  answer_required: boolean
  answer_choices: string[]
  answer_text: string
  question_scope: string
}

export interface CoverPhoto {
  thumbnail: string
  medium: string
  caption: string
  credits: string
  source: string
}

export interface Organizer {
  id: number
  name: string
  website: string
  phone: string
  email: string
  description: string
  twitter: string
  facebook: string
  instagram: string
  snapchat: string
}

export interface RegistrationStatistics {
  registration_amount: number
  amount_unread: number
  waiting_list_occupied: number
  registration_amount_male: number
  registration_amount_yes_male: number
  registration_amount_without_rejected: number
  registration_amount_yes: number
  registration_amount_female: number
  registration_amount_yes_female: number
  registration_amount_diverse: number
  registration_amount_yes_diverse: number
  is_max_participants_full: boolean
  is_male_participants_full: boolean
  is_female_participants_full: boolean
  is_diverse_participants_full: boolean
  is_max_participants_crowded: boolean
  is_max_participants_crowded_by_category: boolean
  is_max_participants_crowded_by_gender: boolean
  is_waiting_list_full: boolean
  is_waiting_list_crowded: boolean
  has_too_many_registrations: boolean
  has_too_many_male_registrations: boolean
  has_too_many_female_registrations: boolean
  has_too_many_diverse_registrations: boolean
  registration_amount_without_rejected_male: number
  registration_amount_without_rejected_female: number
  registration_amount_without_rejected_diverse: number
  event_occupation_bar_data: EventOccupationBarData
  gender_info_combined: GenderInfos
  effectively_occupied_places_amount: number
}

export interface GenderInfos {
  [key: string]: number[]
}

export interface EventOccupationBarData {
  male_per: number
  female_per: number
  diverse_per: number
  total_per: number
}

export type IEvent = {
  id: number
  event_id: number
  relative_id: number
  title: string
  description: string
  description_html: string
  teaser: string
  name: string
  slotsTotal: number
  slotsUsed: number
  timespans?: Timespan[]
  gender: string
  min_age: number
  max_age: number
  custom_age_field: string
  price: number
  hide_price: boolean
  custom_fields: CustomAnswer[]
  price_categories: PriceCategory[]
  registration_custom_fields: CustomQuestion[]
  label_special_notes: string
  duration_summary: string
  cover_photo: CoverPhoto
  photos: CoverPhoto[]
  is_only_for_special_customers: boolean
  has_external_payment: boolean
  has_external_registration: boolean
  canceled: boolean
  supported_disabilities: string
  is_only_for_adults: boolean
  male_participant_amount: number
  female_participant_amount: number
  diverse_participant_amount: number
  registration_statistics: RegistrationStatistics
  max_participants: number
  has_free_non_reserved_places: boolean
  name_public: string
  phone_public: string
  email_public: string
  meeting_point: string
  get_location_link: string
  organizer: Organizer
  tags: string[]
  start: string
  end: string
  allowed_genders: string
  attachments: IEventAttachment[]
  excluded_events: string[]
  conflicting_events: string[]
  show_hours: boolean
  ignore_time_conflicts: boolean
  accesskey_categories: IAccesskeyCategories[]
  workflow_status: string
  first_registration_date: Date
  get_remaining_soft_quota_slots: string
  custom_price: number
}

export type IEventAttachment = {
  title: string
  url: string
}

export type IAccesskeyCategories = {
  id: number
  name: string
  quota: number
  quota_type: string
  used: number
}
